import { ListagemPadrao } from "../../padronizado/listagem-padrao";
import { UsuarioVisualizadoInterface } from "../../../types/UsuarioInterface";
import { verificaSeAtivoERetornaBadge } from "../../../utils/verificaSeAtivoERetornaBadge/verificaSeAtivoERetornaBadge";
import { ColunaTabela } from "../../../components/Formularios/Table/CustomTable";
import { CampoPesquisa } from "../../../components/Modais/ModalFiltro";

// Definição das colunas da tabela
const colunas: ColunaTabela<UsuarioVisualizadoInterface>[] = [
  { key: "id_usuario", label: "Código" },
  { key: "nome", label: "Nome" },
  { key: "nome_usuario", label: "Usuário" },
  { key: "email", label: "E-mail" },
  { key: "telefone", label: "Telefone" },
  {
    key: "situacao",
    label: "Situação",
    render: (situacao) => verificaSeAtivoERetornaBadge(String(situacao)),
    align: "center",
  },
];

// Campos exibidos no modal de pesquisa (filtrados no servidor)
const camposPesquisa: CampoPesquisa<UsuarioVisualizadoInterface>[] = [
  { campo: "nome", label: "Nome" },
  { campo: "nome_usuario", label: "Usuário" },
];

export const Usuario: React.FC = () => {
  // Função para personalizar a mensagem de confirmação de exclusão
  const mensagemConfirmacaoExclusao = (usuario: UsuarioVisualizadoInterface) => {
    return `Tem certeza que deseja excluir o usuário(a) \n ${usuario.nome}?`;
  };

  return (
    <ListagemPadrao<UsuarioVisualizadoInterface>
      titulo="Usuários"
      tela="usuario"
      endpoint="/usuarios"
      colunas={colunas}
      campoId="id_usuario"
      rotaBase="/cadastro/usuario"
      camposPesquisa={camposPesquisa}
      usaPaginacaoServidor={true}
      mensagemConfirmacaoExclusao={mensagemConfirmacaoExclusao}
    />
  );
};
